import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import { LogoEmisor } from 'src/app/models/Emisor/LogoEmisor';
import { EmisorService } from 'src/app/services/emisor.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-logo-uploader-modal',
  templateUrl: './logo-uploader-modal.component.html',
  styleUrls: ['./logo-uploader-modal.component.scss']
})
export class LogoUploaderModalComponent implements OnInit {
  @Input() relatedEmisor: Emisor;
  @Output() logoUploaded = new EventEmitter<any>();
  @Input() currentLogoEmisor: LogoEmisor | undefined;
	public loading: boolean = false;
  constructor(public activeModal: NgbActiveModal, private emisorService: EmisorService, private ref: ChangeDetectorRef) {}

  ngOnInit() {}
  handleLogoRequest(event: any) {
    this.loading = true;
    if (this.currentLogoEmisor) {
			event.logoId = this.currentLogoEmisor.logoId;
      this.emisorService.updateLogo(event).subscribe({
        next: (resp) => {
          this.loading = false;
          Swal.fire('Logo actualizado', 'Se ha actualizado el logo', 'success');
          this.logoUploaded.emit();
          this.activeModal.close();
        },
        error: (err) => {
          this.loading = false;
          Swal.fire('Error al actualizar logo', 'Ha ocurrido un error al actualizar el logo', 'error');
        }
      });
    }
    else{
      this.emisorService.addLogo(event).subscribe({
        next: (resp) => {
          this.loading = false;
          Swal.fire('Logo agregado', 'Se ha actualizado el logo', 'success');
          this.logoUploaded.emit(event.logoFile);
          this.activeModal.close();
        },
        error: (err) => {
          this.loading = false;
          Swal.fire('Error al agregar logo', 'Ha ocurrido un error al actualizar el logo', 'error');
        }
      });
    }
    
  }

  closeModal() {
    this.activeModal.dismiss();
  }

}
